export default "__VITE_ASSET__DgDjcVeQ__"